export default __webpack_public_path__ + "static/afirm-group-logo-tm_blue-e9a50916d838f4bdcf34cfb69ce46555.png";